module.exports = __webpack_public_path__ + "9fcd0ec16acb27eb8a18701620ae1ade.png";